import React, { useEffect, useMemo, useState } from "react";
import { Button, makeStyles } from "@material-ui/core";
import AddOrEditFileDialog from "../fileBrowser/AddOrEditFileDialog";
import localforage from "localforage";
import { useTranslation } from "@/langs/useTranslation";
import { DeleteOutlineOutlined } from "@material-ui/icons";
import { handleS3pathDownload } from "@/apis/announcementApi";
import getFileIcon from "@/helpers/fileIcon";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(2),
    height: 35,
    padding: "7.5px 50px 7.5px 14px",
    verticalAlign: "middle",

    "&:hover .single-select-close": {
      visibility: "visible"
    }
  },
  noEmpty: {
    padding: 0,
    minWidth: 80,

    "& .default-value": {
      position: "absolute",
      left: 10,
      top: "50%",
      transform: "translateY(-50%)"
    }
  },
  small: {
    "& .MuiOutlinedInput-input": {
      paddingTop: 9.5,
      paddingBottom: 9.5,
      paddingRight: 50
    }
  },
  select: {
    position: "absolute",
    left: 0,
    top: 0
  },
  close: {
    position: "absolute",
    right: 26,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.text.secondary,
    fontSize: 16,
    cursor: "pointer",
    visibility: "hidden",
    zIndex: 10,

    "&:hover": {
      color: "#444"
    }
  },
  list: {
    marginTop: "20px",
    backgroundColor: "#f1f1f1",
    borderRadius: 5,
    padding: "10px 10px 1px"
  },
  item: {
    display: "flex",
    height: "30px",
    alignItems: "center",
    marginBottom: 10
  },
  itemText: {
    marginRight: "8px",
    flex: 1
  },
  deleteIcon: {
    cursor: "pointer",
    color: "red"
  }
}));

const UpdateFile = ({ value, onChange, disabled }) => {
  const { t } = useTranslation("accessManagement");
  const classes = useStyles();
  const [fileVisible, setFileVisible] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [availableStorage, setAvailableStorage] = useState("");
  const [parentId] = useState("");
  const [isFECHQ, setIsFECHQ] = useState(false);

  const valueList = useMemo(() => {
    try {
      const valueStr = value || "[]";
      return JSON.parse(valueStr);
    } catch (e) {
      console.log(e);
      return [];
    }
  }, [value]);

  const handleDelete = path => {
    onChange(JSON.stringify(valueList?.filter(file => file.s3Path !== path)));
  };

  const handleChange = file => {
    onChange(JSON.stringify(valueList.concat([file])));
    setFileVisible(false);
  };

  const getCapacityData = async () => {
    let companyId = await localforage.getItem("userCompanyID");
    const capacityObj = false;
    let userData = await localforage.getItem("user");
    setCompanyId(companyId);
    if (capacityObj && userData) {
      let isParentCompanyNull = !userData.company.parent_company_id;
      let availableStorage = capacityObj.total - capacityObj.used;

      setAvailableStorage(availableStorage);

      if (isParentCompanyNull) {
        setIsFECHQ(true);
      }

      // stored the available storage for file uploading validation
      await localforage.setItem(
        `${companyId}-availableStorage`,
        availableStorage
      );
    }
  };

  const getAvailableStorageData = async () => {
    if (!isFECHQ) {
      let availableStorage = await localforage.getItem(
        `${companyId}-availableStorage`
      );
      setAvailableStorage(availableStorage);
    } else {
      setAvailableStorage("unlimited");
    }
  };

  useEffect(() => {
    getCapacityData();
  }, []);

  return (
    <div>
      {!disabled && (
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: "auto", width: 150, height: 40 }}
          onClick={() => setFileVisible(true)}
        >
          {t({ defaultMessage: "上传文件" })}
        </Button>
      )}
      {valueList?.length > 0 && (
        <div className={classes.list}>
          {valueList?.map(file => {
            const Icon = getFileIcon(file.name);
            return (
              <div
                className={classes.item}
                key={file.s3Path}
                onClick={() => handleS3pathDownload(file.s3Path)}
              >
                <div style={{ fontSize: 16, marginRight: 10 }}>
                  <Icon />
                </div>
                <div className={classes.itemText}>{file.name}</div>
                {!disabled && (
                  <DeleteOutlineOutlined
                    className={classes.deleteIcon}
                    onClick={e => {
                      e.stopPropagation();
                      handleDelete(file.s3Path);
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
      <AddOrEditFileDialog
        companyId={companyId}
        availableStorage={availableStorage}
        getAvailableStorageData={getAvailableStorageData}
        isFECHQ={isFECHQ}
        open={fileVisible}
        data={{}}
        setRefreshCapacity={() => {}}
        parentId={parentId}
        reloadTable={() => {}}
        onClose={() => setFileVisible(false)}
        handleChange={handleChange}
      />
    </div>
  );
};

export default UpdateFile;
